import script from './SpinnerDots.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"spinner-dots"})};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-66bb7f19_0", { source: ".spinner-dots[data-v-66bb7f19]{content:\" \";margin-right:8px;width:20px;height:20px;position:relative;text-align:center;animation:sk-rotate-data-v-66bb7f19 2s infinite linear}.spinner-dots[data-v-66bb7f19]:after,.spinner-dots[data-v-66bb7f19]:before{content:\" \";width:50%;height:50%;display:inline-block;position:absolute;top:0;background-color:currentColor;border-radius:100%;animation:sk-bounce-data-v-66bb7f19 2s infinite ease-in-out}.spinner-dots[data-v-66bb7f19]:after{top:auto;bottom:0;animation-delay:-1s}@keyframes sk-rotate-data-v-66bb7f19{100%{transform:rotate(360deg)}}@keyframes sk-bounce-data-v-66bb7f19{0%,100%{transform:scale(0)}50%{transform:scale(1)}}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-66bb7f19";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
